import d,{forwardRef as c}from"react";var t=c(({variant:e="primary",children:o,className:r="","data-id":n,disabled:a,...i},s)=>d.createElement("button",{ref:s,"data-id":n,disabled:a,className:`px-6 py-2.5 rounded-lg font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 ${{primary:`
        bg-button text-white
        hover:bg-button-hover
        active:bg-button-active
        disabled:bg-brand-accent disabled:text-text-disabled disabled:cursor-not-allowed
        focus:ring-button
      `,white:`
        bg-white text-button border-2 border-transparent
        hover:bg-brand-accent hover:text-button-active
        active:bg-brand-accent active:text-button-active
        disabled:bg-brand-accent disabled:text-text-disabled disabled:cursor-not-allowed
        focus:ring-button
      `,text:`
        bg-transparent text-text-default underline
        hover:text-button-active hover:no-underline
        active:text-button-active active:no-underline
        disabled:text-text-disabled disabled:cursor-not-allowed disabled:no-underline
        focus:ring-button
      `}[e]} ${r}`.trim(),...i},o));t.displayName="Button";var u={text:{default:"#151515",subtle:"#464646",disabled:"#6A6A6A"},brand:{primary:"#92288D",secondary:"#F9ECF8",accent:"#F0F0F0"},button:{default:"#92288D",hover:"#581855",active:"#1D081C"},navigation:{default:"#92288D",hover:"#581855",active:"#1D081C"}};export{t as Button,u as colors};
//# sourceMappingURL=index.js.map
